<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <Toast/>
        <div class="row">
          <div class="col-md-12">
            <label for="example-text-input" class="form-control-label">¿Cuál es tu nombre?</label>
            <input type="text" v-model="nombre" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Escribe tu e-mail</label>
            <input type="email" v-model="email" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Escribe tu teléfono <small class="text-secondary">(Opcional)</small></label>
            <input type="tel" v-model="telefono" class="form-control">
          </div>
          <div class="col-md-12">
            <label class="form-control-label">¿Cómo podemos ayudarte?</label>
            <Textarea v-model="mensaje" rows="2" class="form-control" />
          </div>
          <div class="col-md-12 text-center">
            <Button class="btn btn-addiuva-dark" style="margin-top:30px;"
                label="Enviar Mensaje"
                icon="fas fa-paper-plane pr-1"
                :loading="loadingButton"
                @click="enviarMensaje"
                :disabled="!formularioValido" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import axios from 'axios';
import Button from 'primevue/button';
// import authHeader from '../services/auth-header';
export default {
  name: "Formulario de Contacto",
  components: {
    Textarea,
    Button,
    Toast
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      nombre: null,
      email: null,
      telefono: null,
      mensaje: null,
      loadingButton: false
    };
  },
  methods: {
    valueIsValid: function(value) {
      return (value !== null && value !== "" && value !== 0 && value !== [] && (typeof value !== "undefined"));
    },
    enviarMensaje: function() {
      if (this.formularioValido) {
        let payload = {
          "nombre": this.nombre,
          "email": this.email,
          "telefono": this.telefono,
          "mensaje": this.mensaje,
        }
        this.loadingButton = true;
        // Send Data by Axios
        let url = this.API_URL + "/contactos/registro";
        axios({
          url: url,
          method: 'post',
          data: payload,
          // headers: authHeader(),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        })
        .then(response => {
          this.loadingButton = false;
          if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Su mensaje fue enviado exitosamente.', life: 3000 });
          } else {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 });
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      }
    },
    isEmailValid: function(email) {
      let validationRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;
      return validationRegex.test(email)
    },
  },
  computed: {
    formularioValido() {
      let isValid = true;
      if (!this.valueIsValid(this.nombre)) { isValid = false; }
      if (!this.valueIsValid(this.email)) { isValid = false; } else if (!this.isEmailValid(this.email)) { isValid = false; }
      if (!this.valueIsValid(this.mensaje)) { isValid = false; }
      return isValid;
    }
  }
};
</script>